import React from 'react';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import _ from 'lodash';

import { getSelectedCandidatesList } from '../../services/sessionTrackServices';
import { API_BASE_URL } from '../../styles/constant';
import AppShell from '../../components/AppShell';
import Loader from '../../components/Loader';
import SessionVisualization from '../../components/SessionVisualization';
import R1Report from './components/R1Report';
import R2Report from './components/R2Report';

class DBIndex extends React.Component {
  state = {
    tabValue: 0,
    dataLoaded: false,
    candidates: [],
  };

  componentDidMount() {
    this.unsubscribe = getSelectedCandidatesList((candidates) => {
      const modifyCandidatesData = this.getModifyCandidatesList(candidates);
      this.setState({ candidates: modifyCandidatesData, dataLoaded: true });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  unsubscribe = null;

  getModifyCandidatesList = (candidatesList) => {
    const updatedList = candidatesList.map(candidateData => ({
      ...candidateData,
      dbIndexR1: candidateData.dbIndexR1
        ? {
          ...candidateData.dbIndexR1,
          monsoonSessionObservation: _.get(
            candidateData,
            'dbIndexR1.monsoonSessionObservation',
            null,
          )
            ? _.get(candidateData, 'dbIndexR1.monsoonSessionObservation')
              .split('_')
              .join(' ')
            : null,
          winterSessionObservation: _.get(
            candidateData,
            'dbIndexR1.winterSessionObservation',
            null,
          )
            ? _.get(candidateData, 'dbIndexR1.winterSessionObservation')
              .split('_')
              .join(' ')
            : null,
          budgetSessionObservation: _.get(
            candidateData,
            'dbIndexR1.budgetSessionObservation',
            null,
          )
            ? _.get(candidateData, 'dbIndexR1.budgetSessionObservation')
              .split('_')
              .join(' ')
            : null,
        }
        : {},
    }));

    return updatedList;
  };

  render() {
    const { dataLoaded, candidates, tabValue } = this.state;

    return (
      <div>
        <AppShell>
          {!dataLoaded ? (
            <Loader />
          ) : (
            <div>
              <TabsContainer>
                <Tabs
                  value={tabValue}
                  onChange={(event, value) => {
                    this.setState({ tabValue: value });
                  }}
                >
                  <Tab label="R1 Report" />
                  <Tab label="R2 Report" />
                  <Tab label="R1 Visualization" />
                  <Tab label="R2 Visualization" />
                </Tabs>
              </TabsContainer>

              {tabValue === 0 && <R1Report candidates={candidates} />}
              {tabValue === 1 && <R2Report candidates={candidates} />}
              {tabValue === 2 && (
                <SessionVisualization apiEndPoint={`${API_BASE_URL}/dbIndex/r1/visualization`} />
              )}
              {tabValue === 3 && (
                <SessionVisualization apiEndPoint={`${API_BASE_URL}/dbIndex/r2/visualization`} />
              )}
            </div>
          )}
        </AppShell>
      </div>
    );
  }
}

export default DBIndex;

const TabsContainer = styled(Paper).attrs({
  elevation: 4,
})`
  margin-bottom: 16px;

  && {
    background: ${props => props.theme.palette.primary.main};
  }

  & * {
    color: ${props => props.theme.palette.primary.contrastText} !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/DBIndex/DBIndex.js